module.exports = __webpack_public_path__ + "static/media/SUT_icon.aa0cf3b4.png";